import {ToggleBarIcon, toggleSwitchButtonSx, ToggleSwitchProps, toggleSwitchSx} from "../components/ToggleBar.tsx";
import {useSelf} from "../agent/useSelf.ts";
import {Button, ToggleButtonGroup} from "@mui/joy";
import {TruckFacet, truckFacetIcons} from "./truckFacet.tsx";

export function TruckFacetToggleSwitch({
                                           value,
                                           dispatchValue,
                                           color: inColor,
                                           variant: inVariant
                                       }: ToggleSwitchProps<TruckFacet>) {
    const {data: self} = useSelf();
    const canDrive = self?.canDrive;
    const color = inColor ?? "primary";
    const variant = inVariant ?? "soft";

    return <ToggleButtonGroup value={value} onChange={(_, next) => {
        if (next) {
            dispatchValue(next);
        }
    }} sx={toggleSwitchSx} color={color} variant={variant}>
        <Button sx={toggleSwitchButtonSx} value="drive" disabled={!canDrive}>
            <ToggleBarIcon icon={truckFacetIcons.drive}/>
        </Button>
        <Button sx={toggleSwitchButtonSx} value="cargo">
            <ToggleBarIcon icon={truckFacetIcons.cargo}/>
        </Button>
        <Button sx={toggleSwitchButtonSx} value="timeline">
            <ToggleBarIcon icon={truckFacetIcons.timeline}/>
        </Button>
    </ToggleButtonGroup>
}